import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles(theme => ({
  tabs: {
    position: "relative",
    width: "100%",
    zIndex: 10,
    backgroundColor: "#efefef",
    overflow: "hidden",
    [theme.breakpoints.up("md")]: {
      width: "200%",
      top: "-24px",
      left: "-24px"
    }
  },
  navigation: {
    backgroundColor: "#efefef",
    bottom: 0,
    zIndex: 10,
    position: "fixed",
    width: "100%",
    display: "block",
    overflow: "hidden",
    textAlign: "center"
  },
  spinner: {
    marginTop: theme.spacing(20)
  },
  manualInput: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  manualInputLabel: {
    marginTop: theme.spacing(1)
  },
  select: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    width: "60%",
    minWidth: "200px"
  },
  card: {
    paddingBottom: theme.spacing(3),
    textAlign: "center"
  },
  scanButton: {
    marginBottom: theme.spacing(2),
    whiteSpace: "nowrap",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  progressContainer: {
    height: theme.spacing(1)
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  section: {
    textAlign: "center"
  },
  field: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(2)
  },
  actionArea: {
    display: "block"
  },
  actionButton: {
    margin: theme.spacing(1),
    whiteSpace: "nowrap",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      width: "80%"
    }
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  scanner: {
    "& > div": {
      flex: 1
    }
  },
  detailsDialog: {
    minHeight: "80%"
  },
  productTab: {
    padding: 0
  },
  productCard: {
    padding: 0,
    margin: 0,
    border: "none"
  },
  productCardHeader: {
    borderBottom: "1px solid #e0e0e0",
    padding: "10px",
    marginBottom: "20px"
  },
  media: {
    maxHeight: 150,
    width: "auto",
    margin: "auto",
    marginBottom: "25px"
  },
  noUpdateInfo: {
    margin: "30px auto 0 auto",
    [theme.breakpoints.up("sm")]: {
      width: "50%"
    }
  }
}));
